// extracted by mini-css-extract-plugin
export default {"btn":"RecentlyAddedRecordsRow_btn__r-kJS","tr":"RecentlyAddedRecordsRow_tr__VMgGO"};